import * as React from 'react'

import {
  Box,
  List,
  TogglerCheckbox,
  Tooltip,
  useToggle,
} from '@factorialco/deprecated-design-system'

import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'

interface Props {
  title: string
  description: string
  disabled: boolean
  onTogglerChange: () => void
  active: boolean
}

export const Item = ({ title, description, disabled, onTogglerChange, active }: Props) => {
  const hasProfessionals = hasFeature('factorial_professionals')
  const [showTooltip, toggleTooltip] = useToggle(false)
  return (
    <List.Item>
      <Box width="full">
        <Box flexDirection="row" width="full" justifyContent="spaceBetween">
          <List.Title>{title}</List.Title>
          <Tooltip.Alt
            open={hasProfessionals && showTooltip}
            toggle={toggleTooltip}
            attachment="bottom center"
            label={i18n.t(
              'app_store_v2.apps.payroll_bundle.settings.incidences.contact_bookkeeper'
            )}
            textAlign="center"
          >
            <TogglerCheckbox
              value={active}
              onChange={() => onTogglerChange()}
              disabled={disabled}
            />
          </Tooltip.Alt>
        </Box>
        {hasProfessionals && <List.Description>{description}</List.Description>}
      </Box>
    </List.Item>
  )
}
